import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { CampaignActionPlan, CampaignActionPlanDraft, TaskCatalogItem } from "../../../shared/types";
import type { WorkspaceActionPlan } from "../lib/work-feed";
function root(brandId: string, campaignId: string) { return `/api/campaigns/${encodeURIComponent(campaignId)}/action-plans`; }
export function useCampaignActionPlans(brandId?: string, campaignId?: string) {
  return useQuery({ queryKey: ["campaign-action-plans", brandId, campaignId], enabled: !!brandId && !!campaignId, retry: false,
    queryFn: () => api.get<{ data: CampaignActionPlan[] }>(`${root(brandId!, campaignId!)}?brand_id=${encodeURIComponent(brandId!)}`) });
}
export function useBrandCampaignActionPlans(brandId?: string) {
  return useQuery({ queryKey: ["campaign-action-plans", brandId, "workspace"], enabled: !!brandId, retry: false,
    queryFn: () => api.get<{ data: WorkspaceActionPlan[] }>(`/api/campaigns/action-plans?brand_id=${encodeURIComponent(brandId!)}`) });
}
export function useCampaignActionPlan(brandId?: string, campaignId?: string, planId?: string) {
  return useQuery({ queryKey: ["campaign-action-plans", brandId, campaignId, planId], enabled: !!brandId && !!campaignId && !!planId, retry: false,
    queryFn: () => api.get<{ data: CampaignActionPlan }>(`${root(brandId!, campaignId!)}/${encodeURIComponent(planId!)}?brand_id=${encodeURIComponent(brandId!)}`) });
}
export function useCampaignPlanCatalog(brandId?: string, campaignId?: string) {
  return useQuery({ queryKey: ["campaign-plan-catalog", brandId, campaignId], enabled: !!brandId && !!campaignId, retry: false,
    queryFn: () => api.get<{ data: TaskCatalogItem[] }>(`${root(brandId!, campaignId!)}/catalog?brand_id=${encodeURIComponent(brandId!)}`) });
}
export function useSaveCampaignActionPlan(brandId?: string, campaignId?: string, planId?: string) {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (input: CampaignActionPlanDraft & { id?: string; expected_revision?: number; status?: "planned" | "archived" }) => {
    if (!brandId || !campaignId) throw new Error("Choose the campaign's brand before saving.");
    const body = { ...input, brand_id: brandId };
    return planId ? api.patch<{ data: CampaignActionPlan }>(`${root(brandId, campaignId)}/${encodeURIComponent(planId)}`, body) : api.post<{ data: CampaignActionPlan }>(root(brandId, campaignId), body);
  }, onSuccess: () => {
    qc.invalidateQueries({ queryKey: ["campaign-action-plans", brandId] });
  } });
}
